import React from 'react';

import IconArrow from './svg/IconArrow';
import ListSectionManager from '../genres/ListSectionManager';

import useGetFromApi from '../../../hooks/useGetFromApi';

function GenresSection({ height, onClick }) {
  const [response] = useGetFromApi(`genres`, `/v4/catalog/genres/`);
  const items = response ? response.items : null;
  return (
    <div className={'flexColumn'} style={{ overflow: 'hidden' }}>
      <div className={'flexColumn'} style={{ height, margin: 8 }}>
        <div className={'menu-left-container selected'} style={{'cursor': 'pointer'}}>
          <div id={`ref-rp`} onClick={onClick} className={'flexRow align top-menu-container selected'}>
            <IconArrow size={22} color={'#8C8C8C'} className={'arrow-genre-menu-back'} />
            <span className={`type-regular fz14`}>Genres</span>
          </div>
        </div>
        <div className={`flexColumn`} style={{ height: height, overflow: 'auto' }}>
          <ListSectionManager items={items} />
        </div>
      </div>
    </div>
  )
}

export default GenresSection;
